var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewindIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19016 9.49508C0.212654 8.73872 0.212653 7.26296 1.19016 6.50659C4.21916 4.16287 7.60147 2.31553 11.2105 1.03375L11.8707 0.799253C13.1027 0.361697 14.405 1.19524 14.572 2.46804C14.7671 3.95583 14.8824 5.46861 14.918 6.98594C15.0314 6.80791 15.1777 6.64517 15.3568 6.50659C18.3858 4.16287 21.7681 2.31553 25.3771 1.03375L26.0374 0.799253C27.2694 0.361697 28.5717 1.19524 28.7386 2.46804C29.2158 6.10675 29.2158 9.89493 28.7386 13.5336C28.5717 14.8064 27.2694 15.64 26.0374 15.2024L25.3771 14.9679C21.7681 13.6861 18.3858 11.8388 15.3568 9.49508C15.1777 9.3565 15.0314 9.19377 14.918 9.01574C14.8824 10.5331 14.7671 12.0458 14.572 13.5336C14.405 14.8064 13.1027 15.64 11.8707 15.2024L11.2105 14.9679C7.60147 13.6861 4.21916 11.8388 1.19016 9.49508Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewindIcon);
export default __webpack_public_path__ + "static/media/RewindIcon.48e6e08a0481b86ef900794526c32230.svg";
export { ForwardRef as ReactComponent };